import { Table, TableBody, TableRow, TableCell, TableContainer } from '@mui/material'
import { Paper } from '@dhl-ui/components'
import type { RenderProps } from '~/modules/ppp/components/renderers/types'

type Props = RenderProps & {
  csvSeparator?: string
}

/*
 * This is a poor man's CSV renderer. It splits the input by line and then by semicolon, and dumps it into a table.
 */
export const CsvRenderer = ({ value, csvSeparator = ';', highlight }: Props) => {
  const lines = value.split('\n')
  const lineShouldBeHighlighted = (line: string) => highlight && line.toLowerCase().includes(highlight.toLowerCase())

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{}}>
        <TableBody>
          {lines.map((line, index) => (
            <TableRow key={index} sx={{ borderBottom: '1px solid lightgrey)' }}>
              {line.split(csvSeparator).map((cell, j) => (
                <TableCell
                  key={j}
                  sx={{
                    borderRight: '1px solid lightgrey',
                    textWrap: 'nowrap',
                    backgroundColor: lineShouldBeHighlighted(line) ? 'secondary.main' : 'transparent',
                  }}
                >
                  {cell?.length > 0 ? cell : '-'}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
